import {Component, Input, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {API_URLS} from 'src/environments/env-routes';
import {APIHelper} from 'src/shared/services/api-helper/api-helper.service';
import {UserService} from 'src/shared/services/user/user.service';
import {DialogLoginComponent} from '../dialog-login/dialog-login.component';

@Component({
  selector: 'app-back-preview',
  templateUrl: './back-preview.component.html',
  styleUrls: ['./back-preview.component.scss']
})
export class BackPreviewComponent implements OnInit {
  @Input() elementId: string;
  public parentId: string;
  constructor(
    private dialog: MatDialog,
    public user: UserService,
    private api: APIHelper
  ) {}

  ngOnInit() {
    this.user.isLoggedIn().then(res => {
      if (res) {
        this.getparentId(this.elementId);
        // Faire requete
      }
    });
  }

  login() {
    const dialogRef = this.dialog.open(DialogLoginComponent, {
      width: '70%',
      height: '40%'
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.getparentId(this.elementId);
      }
    });

    // Gérer eevenement popup fermeture
    // ET faire requete
  }
  getparentId(id) {
    const args = 'include=allowableOperations';

    this.api
      .requestApi({
        action: API_URLS.nodes.nodes.replace(':nodeId', id),
        queryArgs: args
      })
      .then(res => {
        this.parentId = res.parentId;
      });
  }
}
